import Vue from "vue";
import Router from "vue-router";
import Home from "../components/Home.vue";
import Player from "../components/Player.vue";
import Category from "../components/Category.vue";
import Calendar from "../components/Calendar.vue";
import Lights from "../components/Lights.vue";
import Likes from "../components/Likes.vue";
import Settings from "../components/Settings.vue";
import Splash from "../components/Splash.vue";
import Help from "../components/Help.vue";
import Live from "../components/Live.vue";
import Loading from "../components/Loading.vue";
import store from "../store/index";

// eslint-disable-next-line no-unused-vars
function requireAuth(to, from, next) {
  if (!store.getters.getUser) {
    next("/Splash");
  } else {
    next();
  }
}

Vue.use(Router);


export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "Splash",
      component: Splash
    },
    {
      path: "/",
      name: "Home",
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: "/Player",
      name: "Player",
      component: Player,
      beforeEnter: requireAuth
    },
    {
      path: "/Category",
      name: "Category",
      component: Category,
      beforeEnter: requireAuth
    },
    {
      path: "/Calendar",
      name: "Calendar",
      component: Calendar,
      beforeEnter: requireAuth
    },
    {
      path: "/Lights",
      name: "Lights",
      component: Lights,
      beforeEnter: requireAuth
    },
    {
      path: "/Live",
      name: "Live",
      component: Live,
      beforeEnter: requireAuth
    },
    {
      path: "/Likes",
      name: "Likes",
      component: Likes
    },
    {
      path: "/Settings",
      name: "Settings",
      component: Settings,
      beforeEnter: requireAuth
    },
    {
      path: "/Help",
      name: "Help",
      component: Help,
      beforeEnter: requireAuth
    },
    {
      path: "/Loading",
      name: "Loading",
      component: Loading
    }
  ],
});


// WEBPACK FOOTER //
// ./src/router/index.js